var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('event-detail-component',{attrs:{"event-type":'eventDetail',"event-key":_vm.eventKey}}),_c('share-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }